var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",class:_vm.$root.siteRenderer},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.copyrightText))]),_c('span',{staticClass:"department"},[_vm._v(_vm._s(_vm.departmentText))])]),_c('div',[_vm._v(" Powered by RAD "+_vm._s(_vm.version)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }